module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "current",
    style: (_vm.theme)
  }, [_c('p', [_vm._v("Color Index: " + _vm._s(_vm.colorIndex))]), _c('p', [_vm._v("Nav Index: " + _vm._s(_vm.navIndex))])]), _c('example-choice-color'), _c('example-circular-nav')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47f38440!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 55
// module chunks = 1